import { render, staticRenderFns } from "./Externo.vue?vue&type=template&id=386d3c9d&scoped=true"
import script from "./Externo.vue?vue&type=script&lang=js"
export * from "./Externo.vue?vue&type=script&lang=js"
import style0 from "./Externo.vue?vue&type=style&index=0&id=386d3c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d3c9d",
  null
  
)

export default component.exports